// GENERATED from IHS Hub APP_ROLE_CATALOG (app_id=it-tickets). Do not edit by hand;
// re-run the hub-access-wiring skill to regenerate. The CommonJS copy lives at
// api/src/shared/access.rooms.generated.js - same symbol->key map (checker asserts parity).
//
// Queried 2026-10-16:
//   SELECT ROLE_KEY FROM IHS_ANALYTICS.APPS.APP_ROLE_CATALOG WHERE APP_ID = 'it-tickets'
//   -> ai-access, it-admin, it-help, service-titan
export const AI_ACCESS = 'ai-access';
export const IT_ADMIN = 'it-admin';
export const IT_HELP = 'it-help';
export const SERVICE_TITAN = 'service-titan';
export const HUB_ROOM_KEYS = { AI_ACCESS, IT_ADMIN, IT_HELP, SERVICE_TITAN }; // must match the CommonJS copy symbol-for-symbol
